import React, { useEffect, useState } from 'react';
import { Wine, Plane, Users, Trophy, GlassWater, GraduationCap, Store, Briefcase, Gift, Star, ArrowRight } from 'lucide-react';
import { getOfferings } from '../lib/api';
import { useSettings } from '../lib/SettingsContext';
import { resolveImg } from '../lib/api';

import { useLang } from '../lib/i18n';
const ICONS = { Wine, Plane, Users, Trophy, GlassWater, GraduationCap, Store, Briefcase, Gift, Star };

export default function QueOfrecemos() {
  const { ui } = useLang();
  const { settings } = useSettings();
  const [offerings, setOfferings] = useState([]);
  useEffect(() => { getOfferings().then(setOfferings).catch(() => {}); }, []);
  const heroImg = resolveImg(settings.hero_images?.[2] || settings.hero_images?.[0] || '');

  return (
    <div>
      <section className="relative h-[55vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 gd-hero-bg" style={{ backgroundImage: `url(${heroImg})` }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(13,13,14,0.6), rgba(13,13,14,0.95))' }} />
        <div className="relative z-10 text-center px-6">
          <div className="gd-eyebrow mb-3">{ui('offer.eyebrow')}</div>
          <h1 className="font-script text-[#c9a063] text-5xl md:text-7xl leading-none">{ui('offer.title')}</h1>
          <p className="font-serif-display text-white text-2xl md:text-3xl mt-4">{ui('offer.sub')}</p>
        </div>
      </section>

      <section className="py-24 px-6 md:px-10 bg-[#0d0d0e]">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {offerings.map((o) => {
            const Icon = ICONS[o.icon] || Wine;
            const hasUrl = !!(o.url && o.url.trim());
            return (
              <div key={o.id} className="bg-white text-zinc-900 p-8 md:p-10 relative shadow-lg hover:shadow-xl transition-shadow flex flex-col">
                {o.badge && <span className="absolute top-5 right-5 text-[10px] uppercase tracking-widest px-2 py-1 border border-[#a07c44] text-[#a07c44] font-sans-ui bg-white">{o.badge}</span>}
                <div className="flex items-start gap-5 mb-5">
                  <div className="w-14 h-14 border border-[#a07c44] flex-shrink-0 flex items-center justify-center text-[#a07c44]"><Icon size={22} /></div>
                  <div>
                    <h3 className="font-serif-display text-2xl md:text-3xl text-zinc-900 mb-3">{o.title}</h3>
                    <p className="text-zinc-700 leading-relaxed text-[16px]">{o.description}</p>
                  </div>
                </div>
                {hasUrl && (
                  <a href={o.url} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center justify-center gap-2 self-start bg-[#a07c44] text-white hover:bg-[#8a6a39] px-6 py-3 text-[11px] uppercase tracking-[0.25em] font-sans-ui font-medium transition-colors">
                    {o.cta_label || 'Más información'} <ArrowRight size={13} />
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
